export default __webpack_public_path__ + "static/media/bd.eefa3086.jpg";